export default __webpack_public_path__ + "static/media/blog-1-300x250.f2470f14.png";